import { useCallback } from 'react'
import { ReactComponent as MedicationHistoryIcon } from 'assets/icons/medication-history.svg'
import { ToolBarButton } from 'components/ToolBarButton'
import useAnalytics from 'hooks/useAnalytics'
import MedicalHistoryModal from 'modals/MedicalHistoryModal'
import { useModalContext } from 'providers/Overlays/ModalProvider'
import { PV1Events } from 'services/analytics/events/pv1Events'
import type { SideToolBarProps } from 'types'

export const MedicationHistoryButton = ({ patientId, fillId }: Partial<SideToolBarProps>) => {
  const { showModal } = useModalContext()
  const { trackPV1Event } = useAnalytics()

  const showMedicalHistory = useCallback(() => {
    if (patientId && fillId) {
      trackPV1Event(PV1Events.PV1_MEDICATION_HISTORY_CLICK.key, {
        fillId: fillId,
      })
      showModal(() => <MedicalHistoryModal patientId={patientId} fillId={fillId} />)
    }
  }, [patientId, fillId, showModal, trackPV1Event])

  return (
    <ToolBarButton
      label="MEDICATION HISTORY"
      icon={MedicationHistoryIcon}
      tooltipText="MEDICATION HISTORY"
      clickCallback={showMedicalHistory}
    />
  )
}
